/* src/app/system-utils/option-dialog/option-dialog.component.scss */
.content-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.options {
  gap: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 16px;
}
/*# sourceMappingURL=option-dialog.component.css.map */
